module.exports = __webpack_public_path__ + "media/gen/gen002-c35b3731.svg";